function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 270C189.379 270 244 262.613 244 253.5V235.5C244 244.613 189.379 252 122 252C54.6213 252 0 244.613 0 235.5V253.5C0 262.613 54.6213 270 122 270Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 270C189.379 270 244 262.613 244 253.5V235.5H122H0V253.5C0 262.613 54.6213 270 122 270Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 235.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 235.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 252C189.379 252 244 244.613 244 235.5C244 235.5 244 234.5 243.5 234.5C238.5 239 224.144 242.187 192 245C155 248.237 113.5 248.864 72.5 247C59.3234 246.401 6.5 242.5 0.500003 234C0 235 0 235.5 0 235.5C0 244.613 54.6213 252 122 252Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 248C195.379 248 250 240.613 250 231.5V213.5C250 222.613 195.379 230 128 230C60.6213 230 6 222.613 6 213.5V231.5C6 240.613 60.6213 248 128 248Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 248C195.379 248 250 240.613 250 231.5V213.5H128H6V231.5C6 240.613 60.6213 248 128 248Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 213.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 213.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 230C195.379 230 250 222.613 250 213.5C250 213.5 250 212.5 249.5 212.5C244.5 217 230.144 220.187 198 223C161 226.237 119.5 226.864 78.5 225C65.3234 224.401 12.5 220.5 6.5 212C6 213 6 213.5 6 213.5C6 222.613 60.6213 230 128 230Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 225C191.379 225 246 217.613 246 208.5V190.5C246 199.613 191.379 207 124 207C56.6213 207 2 199.613 2 190.5V208.5C2 217.613 56.6213 225 124 225Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 225C191.379 225 246 217.613 246 208.5V190.5H124H2V208.5C2 217.613 56.6213 225 124 225Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 190.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 190.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 207C191.379 207 246 199.613 246 190.5C246 190.5 246 189.5 245.5 189.5C240.5 194 226.144 197.187 194 200C157 203.237 115.5 203.864 74.5 202C61.3234 201.401 8.5 197.5 2.5 189C2 190 2 190.5 2 190.5C2 199.613 56.6213 207 124 207Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 203C194.379 203 249 195.613 249 186.5V168.5C249 177.613 194.379 185 127 185C59.6213 185 5 177.613 5 168.5V186.5C5 195.613 59.6213 203 127 203Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 203C194.379 203 249 195.613 249 186.5V168.5H127H5V186.5C5 195.613 59.6213 203 127 203Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 168.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 168.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 185C194.379 185 249 177.613 249 168.5C249 168.5 249 167.5 248.5 167.5C243.5 172 229.144 175.187 197 178C160 181.237 118.5 181.864 77.5 180C64.3234 179.401 11.5 175.5 5.5 167C5 168 5 168.5 5 168.5C5 177.613 59.6213 185 127 185Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 178C198.379 178 253 170.613 253 161.5V143.5C253 152.613 198.379 160 131 160C63.6213 160 9 152.613 9 143.5V161.5C9 170.613 63.6213 178 131 178Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 178C198.379 178 253 170.613 253 161.5V143.5H131H9V161.5C9 170.613 63.6213 178 131 178Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 143.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 143.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 160C198.379 160 253 152.613 253 143.5C253 143.5 253 142.5 252.5 142.5C247.5 147 233.144 150.187 201 153C164 156.237 122.5 156.864 81.5 155C68.3234 154.401 15.5 150.5 9.5 142C9 143 9 143.5 9 143.5C9 152.613 63.6213 160 131 160Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M122 156C189.379 156 244 148.613 244 139.5V121.5C244 130.613 189.379 138 122 138C54.6213 138 0 130.613 0 121.5V139.5C0 148.613 54.6213 156 122 156Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M122 156C189.379 156 244 148.613 244 139.5V121.5H122H0V139.5C0 148.613 54.6213 156 122 156Z",
  fill: "url(#paint15_linear)",
  fillOpacity: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 121.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 121.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint16_linear)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M122 138C189.379 138 244 130.613 244 121.5C244 121.5 244 120.5 243.5 120.5C238.5 125 224.144 128.187 192 131C155 134.237 113.5 134.864 72.5 133C59.3234 132.401 6.5 128.5 0.500003 120C0 121 0 121.5 0 121.5C0 130.613 54.6213 138 122 138Z",
  fill: "url(#paint17_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M132 137C199.379 137 254 129.613 254 120.5V102.5C254 111.613 199.379 119 132 119C64.6213 119 10 111.613 10 102.5V120.5C10 129.613 64.6213 137 132 137Z",
  fill: "currentColor"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M132 137C199.379 137 254 129.613 254 120.5V102.5H132H10V120.5C10 129.613 64.6213 137 132 137Z",
  fill: "url(#paint18_linear)",
  fillOpacity: 0.25
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint19_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M132 119C199.379 119 254 111.613 254 102.5C254 102.5 254 101.5 253.5 101.5C248.5 106 234.144 109.187 202 112C165 115.237 123.5 115.864 82.5 114C69.3234 113.401 16.5 109.5 10.5 101C10 102 10 102.5 10 102.5C10 111.613 64.6213 119 132 119Z",
  fill: "url(#paint20_linear)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M124 112C191.379 112 246 104.613 246 95.4999V77.5C246 86.6127 191.379 94 124 94C56.6213 94 2 86.6127 2 77.5V95.4999C2 104.613 56.6213 112 124 112Z",
  fill: "currentColor"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M124 112C191.379 112 246 104.613 246 95.4999V77.5H124H2V95.4999C2 104.613 56.6213 112 124 112Z",
  fill: "url(#paint21_linear)",
  fillOpacity: 0.25
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 77.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 77.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint22_linear)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M124 94C191.379 94 246 86.6127 246 77.5C246 77.5 246 76.5 245.5 76.5C240.5 81 226.144 84.1874 194 87C157 90.2375 115.5 90.8636 74.5 89C61.3234 88.401 8.5 84.5 2.5 76C2 77 2 77.5 2 77.5C2 86.6127 56.6213 94 124 94Z",
  fill: "url(#paint23_linear)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M127 86.9999C194.379 86.9999 249 79.6126 249 70.4999V52.5C249 61.6127 194.379 69 127 69C59.6213 69 5 61.6127 5 52.5V70.4999C5 79.6126 59.6213 86.9999 127 86.9999Z",
  fill: "currentColor"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M127 86.9999C194.379 86.9999 249 79.6126 249 70.4999V52.5H127H5V70.4999C5 79.6126 59.6213 86.9999 127 86.9999Z",
  fill: "url(#paint24_linear)",
  fillOpacity: 0.25
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 52.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 52.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint25_linear)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M127 69C194.379 69 249 61.6127 249 52.5C249 52.5 249 51.5 248.5 51.5C243.5 56 229.144 59.1874 197 62C160 65.2375 118.5 65.8636 77.5 64C64.3234 63.401 11.5 59.5 5.5 51C5 52 5 52.5 5 52.5C5 61.6127 59.6213 69 127 69Z",
  fill: "url(#paint26_linear)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M130 61.9999C197.379 61.9999 252 54.6126 252 45.4999V27.5C252 36.6127 197.379 44 130 44C62.6213 44 8 36.6127 8 27.5V45.4999C8 54.6126 62.6213 61.9999 130 61.9999Z",
  fill: "currentColor"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M130 61.9999C197.379 61.9999 252 54.6126 252 45.4999V27.5H130H8V45.4999C8 54.6126 62.6213 61.9999 130 61.9999Z",
  fill: "url(#paint27_linear)",
  fillOpacity: 0.25
});

var _ref49 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 130,
  cy: 27.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 130,
  cy: 27.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint28_linear)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M130 44C197.379 44 252 36.6127 252 27.5C252 27.5 252 26.5 251.5 26.5C246.5 31 232.144 34.1874 200 37C163 40.2375 121.5 40.8636 80.5 39C67.3234 38.401 14.5 34.5 8.5 26C8 27 8 27.5 8 27.5C8 36.6127 62.6213 44 130 44Z",
  fill: "url(#paint29_linear)"
});

var _ref52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 270,
  x2: 118,
  y2: 270,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 224,
  x2: 122,
  y2: 246,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 252,
  x2: 244,
  y2: 252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 248,
  x2: 124,
  y2: 248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 202,
  x2: 128,
  y2: 224,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 230,
  x2: 250,
  y2: 230,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 225,
  x2: 120,
  y2: 225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 179,
  x2: 124,
  y2: 201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 207,
  x2: 246,
  y2: 207,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 203,
  x2: 123,
  y2: 203,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 157,
  x2: 127,
  y2: 179,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 185,
  x2: 249,
  y2: 185,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 178,
  x2: 127,
  y2: 178,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 132,
  x2: 131,
  y2: 154,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.19
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 160,
  x2: 253,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 244,
  y1: 156,
  x2: 118,
  y2: 156,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 137,
  y1: 110,
  x2: 122,
  y2: 132,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: -3.63368e-8,
  y1: 138,
  x2: 244,
  y2: 138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 254,
  y1: 137,
  x2: 128,
  y2: 137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 147,
  y1: 91,
  x2: 132,
  y2: 113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 10,
  y1: 119,
  x2: 254,
  y2: 119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 246,
  y1: 112,
  x2: 120,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 139,
  y1: 66,
  x2: 124,
  y2: 88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 2,
  y1: 93.9999,
  x2: 246,
  y2: 93.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 249,
  y1: 87,
  x2: 123,
  y2: 87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 142,
  y1: 41,
  x2: 127,
  y2: 63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 5,
  y1: 68.9999,
  x2: 249,
  y2: 68.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear",
  x1: 252,
  y1: 62,
  x2: 126,
  y2: 62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear",
  x1: 145,
  y1: 16,
  x2: 130,
  y2: 38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear",
  x1: 8,
  y1: 43.9999,
  x2: 252,
  y2: 43.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg10Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 278,
    viewBox: "0 0 259 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Chip);
export default __webpack_public_path__ + "static/media/10chip.7e0196aa.svg";
export { ForwardRef as ReactComponent };